<template>
  <main>
    <component
      :is="pageTemplate"
      :page="page"
      :site="site"
    />
  </main>
</template>

<script>
import { getMetaData } from '../utils/meta-info'
import { pageTypesMapping } from '../utils/settings'

export default {
  name: 'MainPage',
  metaInfo () {
    return getMetaData({ page: this.page, site: this.site })
  },
  components: {
    GlossaryPage: () =>
      import(/* webpackChunkName: 'page/glossary-page' */ './GlossaryPage.vue'),
    LandingPage: () =>
      import(/* webpackChunkName: 'page/landing-page' */ './LandingPage.vue'),
    PartnerPage: () =>
      import(/* webpackChunkName: 'page/partner-page' */ './PartnerPage.vue'),
    PartnerListPage: () =>
      import(
        /* webpackChunkName: 'page/partner-list-page' */ './PartnerListPage.vue'
      )
  },
  props: {
    page: {
      type: Object,
      required: true
    },
    site: {
      type: String,
      required: true,
      validator: (site) =>
        [
          'zmarta',
          'centum',
          'freedomfinance',
          'freedomrahoitus',
          'elskling'
        ].includes(site.split('.').shift())
    }
  },
  computed: {
    pageTemplate () {
      const pageType = this.page?.content?.contentType
      const pageTemplate = pageTypesMapping[pageType]

      if (!pageTemplate) throw new Error('Invalid pageType')

      return pageTemplate
    }
  }
}
</script>
